export default __webpack_public_path__ + "static/media/frg--orchard-parklands.b54807a9.png";